<template>
    <span class="card-icon">
        <i :class="image"></i>
    </span>
</template>

<script>

export default {
  name: 'cardIcon',

  props: {
    image: {
      type: String
    }
  }
}
</script>

<style scoped>
.card-icon{
  font-size:3rem;
  color:#006558;
}
</style>
